import React, { useRef, useState } from "react";
import { NodeViewWrapper } from "@tiptap/react";

import { IconComponent } from "../../../components/icons";
import {
	Button,
	Input,
	Popover,
	PopoverContent,
	PopoverTrigger,
	Tabs,
	TabsContent,
	TabsList,
	TabsTrigger
} from "../../../components/ui";
import { useLocale } from "../../../locales";
import { KonfhubButton } from "../../../../Atom/Buttons";

function VideoUploaderView(props) {
	const { t } = useLocale();
	const { editor, getPos, deleteNode } = props;

	const [link, setLink] = useState("");
	const [loading, setLoading] = useState(false);
	const fileInput = useRef(null);

	function handleFile(event) {
		setLoading(true);
		const files = event?.target?.files;
		if (!editor || editor.isDestroyed || files.length === 0) {
			return;
		}
		const file = files[0];
		const uploadOptions = editor.extensionManager.extensions.find(
			extension => extension.name === "videoUpload"
		)?.options;
		uploadOptions?.upload([file]).then(res => {
			editor
				.chain()
				.setVideo({ src: res[0].src, width: "100%" })
				.deleteRange({ from: getPos(), to: getPos() })
				.focus()
				.run();
			setLoading(false);
		});
	}
	function handleLink() {
		editor
			.chain()
			.setVideo({
				src: link,
				width: "100%"
			})
			.deleteRange({ from: getPos(), to: getPos() })
			.focus()
			.run();
	}
	function handleDelete(e) {
		e.preventDefault();
		deleteNode();
	}
	function handleClick(e) {
		fileInput.current?.click();
	}

	return (
		<NodeViewWrapper as="div" data-drag-handle>
			<Popover defaultOpen>
				<PopoverTrigger asChild>
					<div className="richtext-flex richtext-items-center richtext-w-full richtext-p-3 richtext-my-3 richtext-transition-all !richtext-border  richtext-cursor-pointer hover:richtext-bg-accent richtext-border-border richtext-text-muted-foreground">
						{loading ? (
							<div className="richtext-flex richtext-items-center richtext-justify-center richtext-gap-3 richtext-text-sm">
								<IconComponent
									className="richtext-w-6 richtext-h-6 richtext-animate-spin"
									name="LoaderCircle"
								/>
								<span>
									{t("editor.video.dialog.uploading")}
									...
								</span>
							</div>
						) : (
							<div className="richtext-flex richtext-items-center richtext-justify-between richtext-w-full">
								<div className="richtext-flex richtext-items-center richtext-justify-center richtext-gap-3">
									<IconComponent
										name="Video"
										className="richtext-w-6 richtext-h-6"
									/>
									<span className="richtext-text-sm">
										{t("editor.video.dialog.title")}
									</span>
								</div>
								<IconComponent
									name="Trash2"
									className="hover:richtext-text-foreground"
									onClick={handleDelete}
								/>
							</div>
						)}
					</div>
				</PopoverTrigger>
				<PopoverContent
					className="richtext-w-full"
					onOpenAutoFocus={e => e.preventDefault()}
				>
					<form>
						<div className="richtext-flex richtext-items-center richtext-gap-2">
							<Input
								type="url"
								autoFocus={true}
								required
								placeholder={t("editor.video.dialog.placeholder")}
								value={link}
								onChange={e => setLink(e.target.value)}
							/>
							<KonfhubButton className='richtext-apply-button' onClick={handleLink}>{t("editor.video.dialog.button.apply")}</KonfhubButton>
						</div>
					</form>
				</PopoverContent>
			</Popover>
		</NodeViewWrapper>
	);
}

export default VideoUploaderView;
